// extracted by mini-css-extract-plugin
export default {"root":"AccountSettingsPage_root__gqfy4","titleWrapper":"AccountSettingsPage_titleWrapper__RVmQ8","sections":"AccountSettingsPage_sections__arJz6"};